import apiClient from '../utils/apiClient';

class ContactService {
    async submitContactForm(data) {
        return apiClient.post('/contact', data);
    }
}

const contactService = new ContactService();

export default contactService;
